export default __webpack_public_path__ + "static/video-banner-98f34e6ccf1a591ce3d65e07c9bc9a42.mp4";